import * as MD from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import * as React from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../../Store';
import {
	deleteACLResource,
	getACLResources,
} from '../../../Store/ResourcesManagement/Actions';
import {
	IResourcesManagementState,
	ACLResource,
} from '../../../Store/ResourcesManagement/Types';
import { I18N } from '../../../Store/I18n/Types';
import { IUserState } from '../../../Store/User/Types';
import { getTheme } from '../../../Themes';
import { isNullOrUndefinedOrEmptyArray } from '../../../Utils/Various';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	resourcesManagement: IResourcesManagementState;
}

interface ISortParams {
	id: 'asc' | 'desc' | undefined;
	name: 'asc' | 'desc' | undefined;
	isparent: 'asc' | 'desc' | undefined;
	type: 'asc' | 'desc' | undefined;
}

interface IState {
	currentID: number;
	openedResource: number[];
	page: number;
	resultsPerPage: number;
	params: ISortParams;
	anchorMenu: null | HTMLElement;
	openDialog: boolean;
	idToDelete: number | null;
}

interface IPropsFromDispatch {
	getACLResources: typeof getACLResources;
	deleteACLResource: typeof deleteACLResource;
}

const theme = getTheme();

const styles = MD.createStyles({
	row: {
		'& > *': {
			borderBottom: 'unset',
		},
	},
	margin: {
		margin: theme.spacing(1),
	},
	noResult: {
		textAlign: 'center',
		fontSize: 'large',
	},
	smallIcon: {
		padding: '3px',
	},
	cell5: {
		width: '5%',
	},
	cell125: {
		width: '12.5%',
	},
	cell15: {
		width: '15%',
	},
	cell20: {
		width: '20%',
	},
	flexContainer: {
		display: 'flex',
		alignItems: 'center',
		boxSizing: 'border-box',
	},
	tableRow: {
		cursor: 'pointer',
	},
	tableRowHover: {
		'&:hover': {
			backgroundColor: theme.palette.grey[200],
		},
	},
	tableCell: {
		flex: 1,
	},
	noClick: {
		cursor: 'initial',
	},
});

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const initialSorting: ISortParams = {
	id: undefined,
	name: undefined,
	isparent: undefined,
	type: undefined,
};

export class AllResourcesComponent extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			currentID: 0,
			openedResource: [],
			page: 0,
			resultsPerPage: 50,
			params: initialSorting,
			anchorMenu: null,
			idToDelete: null,
			openDialog: false,
		};
	}

	public componentDidMount() {
		if (
			isNullOrUndefinedOrEmptyArray(
				this.props.resourcesManagement.allACLResources
			)
		) {
			this.props.getACLResources(this.props.user.token);
		}
	}

	componentWillUnmount() { }

	public render(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				{this.state.openDialog && this.drawConfirmationDialog()}
				{this.props.resourcesManagement.loadingACLResources ? (
					<div style={{ paddingTop: 30 }}>
						{this.props.i18n._('Loading')}...
					</div>
				) : (
					<>
						<MD.TablePagination
							component="div"
							count={this.filterResources().length}
							rowsPerPage={this.state.resultsPerPage}
							page={this.state.page}
							rowsPerPageOptions={[10, 20, 50, 100]}
							onPageChange={(
								event: React.MouseEvent<HTMLButtonElement> | null,
								page: number
							) => {
								this.setState({
									...this.state,
									page,
								});
							}}
							onRowsPerPageChange={(
								event: React.ChangeEvent<
									HTMLTextAreaElement | HTMLInputElement
								>
							) => {
								const rows = parseInt(event.target.value, 10);

								if (isNaN(rows)) {
									return;
								}
								this.setState({
									...this.state,
									page: 0,
									resultsPerPage: rows,
								});
							}}
						/>
						<MD.TableContainer component={MD.Paper}>
							<MD.Table
								aria-label="collapsible table"
								size="small"
							>
								<MD.TableHead>
									<MD.TableRow id="tablerowuser">
										<MD.TableCell
											className={classes.cell5}
											align="left"
										></MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params.id !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id:
																this.state
																	.params
																	.id ===
																	undefined ||
																	this.state
																		.params
																		.id ===
																	'desc'
																	? 'asc'
																	: 'desc',
															name: undefined,
															type: undefined,
															isparent: undefined,
														},
													});
												}}
												direction={this.state.params.id}
											>
												ID
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params.name !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															type: undefined,
															isparent: undefined,
															name:
																this.state
																	.params
																	.name ===
																	undefined ||
																	this.state
																		.params
																		.name ===
																	'desc'
																	? 'asc'
																	: 'desc',
														},
													});
												}}
												direction={
													this.state.params.name
												}
											>
												{this.props.i18n._('Name')}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params
														.isparent !== undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name: undefined,
															isparent:
																this.state
																	.params
																	.isparent ===
																	undefined ||
																	this.state
																		.params
																		.isparent ===
																	'desc'
																	? 'asc'
																	: 'desc',
															type: undefined,
														},
													});
												}}
												direction={
													this.state.params.isparent
												}
											>
												{this.props.i18n._(
													'Is Parent ?'
												)}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											<MD.TableSortLabel
												active={
													this.state.params.type !==
													undefined
												}
												onClick={() => {
													this.setState({
														...this.state,
														params: {
															id: undefined,
															name: undefined,
															isparent: undefined,
															type:
																this.state
																	.params
																	.type ===
																	undefined ||
																	this.state
																		.params
																		.type ===
																	'desc'
																	? 'asc'
																	: 'desc',
														},
													});
												}}
												direction={
													this.state.params.type
												}
											>
												{this.props.i18n._('Type')}
											</MD.TableSortLabel>
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
										>
											{this.props.i18n._('Update')}
										</MD.TableCell>
									</MD.TableRow>
								</MD.TableHead>
								{this.displayTableBody()}
							</MD.Table>
						</MD.TableContainer>
					</>
				)}
			</React.Fragment>
		);
	}

	private filterResources(): ACLResource[] {
		let filteredResources = this.props.resourcesManagement.allACLResources;

		filteredResources = filteredResources.filter(
			(value) => value.parent === null
		);
		/*if (this.props.appsManagement.AllResourcessFilter === null) {
			return filteredResources;
		}
		const filter = this.props.appsManagement.AllResourcessFilter;

		if (this.props.router.match.params.type === 'mediaarchiver-stt') {
			const allowedid = [
				163859, 170738, 169078, 168239, 76770, 76771, 76772, 76769,
				76762, 76761, 557, 166859, 165038, 555, 548, 37981,
			];
			if (filter.id !== null) {
				const id = filter.id;
				if (filter.isIdContained !== null && filter.isIdContained) {
					filteredResources = filteredResources.filter((filteredMedia) =>
						filteredMedia.id.toString().includes(id.toString())
					);
				}
				if (filter.isIdDifferent !== null && filter.isIdDifferent) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.id !== id
					);
				}
				if (filter.isIdEqual !== null && filter.isIdEqual) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.id === id
					);

					filteredResources = filteredResources.filter((filteredMedia) =>
						allowedid.includes(filteredMedia.id)
					);
					return filteredResources;
				}

				filteredResources = filteredResources.filter((filteredMedia) =>
					allowedid.includes(filteredMedia.id)
				);
			}
		} else {
			if (filter.id !== null) {
				const id = filter.id;
				if (filter.isIdContained !== null && filter.isIdContained) {
					filteredResources = filteredResources.filter((filteredMedia) =>
						filteredMedia.id.toString().includes(id.toString())
					);
				}
				if (filter.isIdDifferent !== null && filter.isIdDifferent) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.id !== id
					);
				}
				if (filter.isIdEqual !== null && filter.isIdEqual) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.id === id
					);
					return filteredResources;
				}
			}
		}

		if (filter.mediaSource !== null) {
			const mediaSource = filter.mediaSource;
			if (
				filter.isMediaSourceContained !== null &&
				filter.isMediaSourceContained
			) {
				filteredResources = filteredResources.filter((filteredMedia) =>
					filteredMedia.mediaSource
						.toString()
						.includes(mediaSource.toString())
				);
			}
			if (
				filter.isMediaSourceDifferent !== null &&
				filter.isMediaSourceDifferent
			) {
				filteredResources = filteredResources.filter(
					(filteredMedia) => filteredMedia.mediaSource !== mediaSource
				);
			}
			if (
				filter.isMediaSourceEqual !== null &&
				filter.isMediaSourceEqual
			) {
				filteredResources = filteredResources.filter(
					(filteredMedia) => filteredMedia.mediaSource === mediaSource
				);
			}
		}

		if (filter.name !== null) {
			const name = filter.name.toLowerCase();
			if (filter.isNameContained !== null && filter.isNameContained) {
				filteredResources = filteredResources.filter((filteredMedia) =>
					filteredMedia.name.toLowerCase().includes(name)
				);
			}
			if (filter.isNameDifferent !== null && filter.isNameDifferent) {
				filteredResources = filteredResources.filter(
					(filteredMedia) =>
						!filteredMedia.name.toLowerCase().includes(name)
				);
			}
			if (filter.isNameEqual !== null && filter.isNameEqual) {
				filteredResources = filteredResources.filter(
					(filteredMedia) => filteredMedia.name.toLowerCase() === name
				);
			}
		}

		if (filter.mediaSourceDuplicate !== null) {
			if (filter.mediaSourceDuplicate) {
				filteredResources = filteredResources.filter(
					(filteredMedia) =>
						filteredMedia.id === filteredMedia.mediaSource
				);
			} else {
				let dups = filteredResources.filter(
					(filteredMedia) =>
						filteredMedia.id !== filteredMedia.mediaSource
				);
				let result = dups.map(({ mediaSource }) => mediaSource);

				filteredResources = filteredResources.filter((filteredMedia) =>
					result.includes(filteredMedia.mediaSource)
				);
			}
		}

		if (filter.isencoded !== null && filter.isencoded === true) {
			filteredResources = filteredResources.filter(
				(filteredMedia) => filteredMedia.encoding === true
			);
		}

		if (filter.firstChunkCompare !== null) {
			const firstChunk = filter.firstChunkCompare;
			if (
				filter.isFirstChunkBefore !== null &&
				filter.isFirstChunkBefore &&
				filter.isFirstChunkAfter !== null &&
				filter.isFirstChunkAfter
			) {
			} else {
				if (
					filter.isFirstChunkAfter !== null &&
					filter.isFirstChunkAfter
				) {
					filteredResources = filteredResources.filter(
						(filteredMedia) =>
							filteredMedia.firstChunk >= firstChunk
					);
				}
				if (
					filter.isFirstChunkBefore !== null &&
					filter.isFirstChunkBefore
				) {
					filteredResources = filteredResources.filter(
						(filteredMedia) =>
							filteredMedia.firstChunk <= firstChunk
					);
				}
			}
		}

		if (filter.lastChunkCompare !== null) {
			const lastChunk = filter.lastChunkCompare;
			if (
				filter.isLastChunkAfter !== null &&
				filter.isLastChunkAfter &&
				filter.isLastChunkBefore !== null &&
				filter.isLastChunkBefore
			) {
			} else {
				if (
					filter.isLastChunkAfter !== null &&
					filter.isLastChunkAfter
				) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.lastChunk >= lastChunk
					);
				}
				if (
					filter.isLastChunkBefore !== null &&
					filter.isLastChunkBefore
				) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.lastChunk <= lastChunk
					);
				}
			}
		}

		if (filter.type !== null) {
			if (
				filter.isTypeRadio &&
				filter.isTypeTV &&
				filter.isTypeRadio !== null &&
				filter.isTypeTV !== null
			) {
			} else {
				if (filter.isTypeTV && filter.isTypeTV !== null) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.type === 2
					);
				}
				if (filter.isTypeRadio && filter.isTypeRadio !== null) {
					filteredResources = filteredResources.filter(
						(filteredMedia) => filteredMedia.type === 1
					);
				}
			}
		}*/
		return filteredResources;
	}

	private sortResources(resources: ACLResource[]): ACLResource[] {
		const params = this.state.params;
		if (params.id !== undefined) {
			if (params.id === 'asc') {
				resources = resources.sort((a, b) => (a.id > b.id ? 1 : -1));
			} else {
				resources = resources.sort((a, b) => (a.id < b.id ? 1 : -1));
			}
		}

		if (params.isparent !== undefined) {
			if (params.isparent === 'asc') {
				resources = resources.sort((a, b) =>
					(a.isparent ? 0 : 1) >= (b.isparent ? 0 : 1) ? 1 : -1
				);
			} else {
				resources = resources.sort((a, b) =>
					(a.isparent ? 0 : 1) <= (b.isparent ? 0 : 1) ? 1 : -1
				);
			}
		}

		if (params.type !== undefined) {
			if (params.type === 'asc') {
				resources = resources.sort((a, b) =>
					a.type.id > b.type.id ? 1 : -1
				);
			} else {
				resources = resources.sort((a, b) =>
					a.type.id < b.type.id ? 1 : -1
				);
			}
		}
		if (params.name !== undefined) {
			if (params.name === 'asc') {
				resources = resources.sort((a, b) =>
					a.name > b.name ? 1 : -1
				);
			} else {
				resources = resources.sort((a, b) =>
					a.name < b.name ? 1 : -1
				);
			}
		}

		return resources;
	}

	private displayTableBody(): React.ReactNode | string {
		const classes = this.props.classes;

		let filteredResources = this.filterResources();
		filteredResources = this.sortResources(filteredResources);

		if (filteredResources.length !== 0) {
			return (
				<MD.TableBody>
					{filteredResources.map((m, i) => this.generateRow(m, i))}
				</MD.TableBody>
			);
			/*return (
				<MD.TableBody>
					{filteredResources
						.slice(
							this.state.page * this.state.resultsPerPage,
							this.state.page * this.state.resultsPerPage +
								this.state.resultsPerPage
						)
						.map((m, i) => this.generateRow(m, i))}
				</MD.TableBody>
			);*/
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={7} className={classes.noResult}>
							No result
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}

	private generateRow(resource: ACLResource, i: number): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell className={classes.cell5}>
						{resource.children.length !== 0 ? (
							<MD.IconButton
								aria-label="expand row"
								size="small"
								onClick={() => {
									if (
										this.state.openedResource.includes(
											resource.id
										)
									) {
										this.onRemoveItemResources(resource.id);
									} else {
										this.onAddItemResources(resource.id);
									}
								}}
							>
								{this.state.openedResource.includes(
									resource.id
								) ? (
									<KeyboardArrowUpIcon />
								) : (
									<KeyboardArrowDownIcon />
								)}
							</MD.IconButton>
						) : (
							''
						)}
					</MD.TableCell>
					<MD.TableCell
						className={classes.cell125}
						component="th"
						scope="row"
					>
						{resource.id}
					</MD.TableCell>
					<MD.TableCell className={classes.cell125} align="left">
						{resource.name}
					</MD.TableCell>
					<MD.TableCell className={classes.cell125} align="left">
						{resource.isparent ? 'true' : 'false'}
					</MD.TableCell>
					<MD.TableCell className={classes.cell125} align="left">
						{[resource.type.id, ' - ', resource.type.name]}
					</MD.TableCell>
					<MD.TableCell className={classes.cell125} align="left">
						<MD.Button
							onClick={() => {
								this.props.router.history.push(
									`/ressources/${resource.id}`
								);
							}}
						>
							Update
						</MD.Button>
						<IconButton
							className={classes.smallIcon}
							color="primary"
							aria-label="edit picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => this.openDeleteForm(resource.id)}
						>
							<DeleteIcon style={{ color: red[500] }} />
						</IconButton>
					</MD.TableCell>
				</MD.TableRow>
				{resource.children === null ? '' : this.subtable(resource, i)}
			</React.Fragment>
		);
	}

	private subtable(resource: ACLResource, i: number): React.ReactNode {
		return (
			<MD.TableRow>
				<MD.TableCell style={{ padding: 0 }} colSpan={7}>
					<MD.Collapse
						in={this.state.openedResource.includes(resource.id)}
						timeout="auto"
						unmountOnExit
					>
						<MD.Table size="small" aria-label="children">
							<MD.TableBody>
								{resource.children.map((u, i) =>
									this.generateRow(u, i)
								)}
							</MD.TableBody>
						</MD.Table>
					</MD.Collapse>
				</MD.TableCell>
			</MD.TableRow>
		);
	}

	private openDeleteForm(id: number) {
		this.setState({
			openDialog: true,
			idToDelete: id,
		});
	}

	private closeDialog() {
		this.setState({ openDialog: false });
	}
	private drawConfirmationDialog() {
		const { i18n } = this.props;
		if (this.state.idToDelete !== null) {
			let id = this.state.idToDelete;
			return (
				<MD.Dialog open={this.state.openDialog}>
					<MD.DialogTitle>
						{' '}
						{this.props.i18n._('Confirm delete resource ?')}{' '}
					</MD.DialogTitle>
					<MD.DialogContent>
						<MD.DialogContentText>
							{this.props.i18n._(
								'Do you really want to delete this resource'
							)}
						</MD.DialogContentText>
					</MD.DialogContent>
					<MD.DialogActions>
						<MD.Button onClick={this.closeDialog.bind(this)}>
							{i18n._('Cancel')}
						</MD.Button>
						<MD.Button
							onClick={() => this.handleResourceDelete(id)}
						>
							{i18n._('Confirm')}
						</MD.Button>
					</MD.DialogActions>
				</MD.Dialog>
			);
		}
		return null;
	}

	private handleResourceDelete(id: number) {
		this.props.deleteACLResource(this.props.user.token, id);
		this.setState({ openDialog: false });
	}

	private onRemoveItemResources(itemToRemove: number) {
		const list = this.state.openedResource;
		const listUpdated = list.filter((item) => item !== itemToRemove);
		this.setState({ openedResource: listUpdated });
	}

	private onAddItemResources(itemToAdd: number) {
		const list = this.state.openedResource;
		list.push(itemToAdd);
		this.setState({ openedResource: list });
	}

	private closeMenuChannel() {
		this.setState({ anchorMenu: null });
	}

	private openMenuChannel(event: React.MouseEvent<HTMLButtonElement>) {
		this.setState({ anchorMenu: event.currentTarget });
	}
}

const mapStateToProps = (
	{ i18n, user, resourcesManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	resourcesManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLResources: (token: string) => dispatch(getACLResources(token)),
	deleteACLResource: (token: string, id: number) =>
		dispatch(deleteACLResource(token, id)),
});

export const AllResources = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(AllResourcesComponent));
